import { Link } from "react-router-dom";
import { LogoMark } from "./Logo";

const SERVICES = ["Residential remodeling", "Light commercial", "New construction & additions", "Custom carpentry", "Kitchen cabinets & granite", "Roofing & repairs"];
const PAGES = [
  { label: "Home", to: "/" },
  { label: "$5K Kitchen Offer", to: "/offer" },
  { label: "Privacy", to: "/privacy" },
];

export const Footer = () => (
  <footer className="bg-ink text-bone overflow-hidden" data-testid="site-footer">
    <div className="mx-auto max-w-[1600px] px-5 sm:px-8 pt-20 pb-10">
      <div className="grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <LogoMark className="h-10 w-10 text-bone" />
          <p className="mt-6 max-w-sm text-base text-bone/60 leading-relaxed">
            Licensed and insured residential and light commercial general contractor. 15+ years serving Delaware, Pennsylvania, New Jersey and Baltimore.
          </p>
          <a href="tel:3022301988" className="mt-6 inline-block font-display font-medium text-2xl tracking-[-0.015em] text-bone hover:text-teal transition-colors" data-testid="footer-phone-link">
            (302) 230-1988
          </a>
        </div>
        <div className="md:col-span-2">
          <p className="font-mono text-[11px] uppercase tracking-[0.16em] text-bone/40">Pages</p>
          <ul className="mt-4 space-y-2">
            {PAGES.map((p) => (
              <li key={p.to}>
                <Link to={p.to} className="font-sans font-medium text-sm text-bone/75 hover:text-teal transition-colors" data-testid={`footer-link-${p.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>{p.label}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-2">
          <p className="font-mono text-[11px] uppercase tracking-[0.16em] text-bone/40">Services</p>
          <ul className="mt-4 space-y-2">
            {SERVICES.map((s) => (
              <li key={s} className="font-sans font-medium text-sm text-bone/75">{s}</li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="font-mono text-[11px] uppercase tracking-[0.16em] text-bone/40">Fine print</p>
          <p className="mt-4 text-xs text-bone/50 leading-relaxed" data-testid="footer-disclaimer">
            The $5,000 guaranteed price covers new cabinets (up to 18) and granite countertops. Kitchens with more than 18 cabinets, additional work (backsplash, flooring, lighting, etc.) and unusual site conditions are quoted separately and clearly before any work begins.
          </p>
        </div>
      </div>

      <p className="mt-20 font-display font-semibold tracking-[-0.035em] leading-[0.9] text-[clamp(1.9rem,7.9vw,8.5rem)] text-bone whitespace-nowrap" aria-hidden="true">
        Construction Alliance
      </p>

      <div className="mt-8 pt-6 border-t border-bone/15 flex flex-col sm:flex-row justify-between gap-3 text-xs text-bone/45">
        <p>© 2026 Construction Alliance, LLC. Licensed & insured. Serving DE, PA, NJ & Baltimore.</p>
        <p className="font-display font-medium text-sm text-bone/70">"Damn. I love my house."</p>
      </div>
    </div>
  </footer>
);
